import styles from './GuidanceCard.scss';
import React, { useContext } from 'react';
import { TrackingContext } from '../../../TrackingContext';
import GuidanceLink from './GuidanceLink';
import TextGuidanceCard from './TextGuidanceCard';

const RegistryCard = () => {
  const { track } = useContext(TrackingContext);
  const onCtaAnalytics = () => {
    track('WWS Dashboard Interaction', {
      action: 'add',
      actionName: 'header registry',
      source: 'wws promo',
    });
  };

  return (
    <GuidanceLink
      className={styles.registryCard}
      onClick={onCtaAnalytics}
      href={'/registry'}
      target="_blank"
      data-testid="promotion-registry-cta"
    >
      <TextGuidanceCard title="Set up your registry" body="Let guests shop all the gifts right from your website." />
    </GuidanceLink>
  );
};

export default RegistryCard;
